class CarouselPlayPauseButton extends HTMLElement {

  /* --------------- *** Constructor & bound handlers *** --------------- */

  constructor() {
    super();

    this._boundHandleClick = this.handleClick.bind(this);
    this._boundHandleKeyDown = this.handleKeyDown.bind(this);
  }

  /* --------------- *** Custom element lifecycle *** --------------- */

  connectedCallback() {
    if (this._lifecycleConnected) return;

    this._lifecycleConnected = true;

    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "button");
    }

    if (!this.hasAttribute("tabindex")) {
      this.setAttribute("tabindex", "0");
    }

    this.setup();
  }

  disconnectedCallback() {
    this.teardown();
    this._lifecycleConnected = false;
  }

  /* --------------- *** Initial wiring & cleanup *** --------------- */

  setup() {
    const slider = this.resolveSlider();

    if (!slider) {
      this.hidden = true;

      return;
    }

    this.hidden = false;
    this.setUiPaused(false);

    this.addEventListener("click", this._boundHandleClick);
    this.addEventListener("keydown", this._boundHandleKeyDown);
  }

  teardown() {
    this.removeEventListener("click", this._boundHandleClick);
    this.removeEventListener("keydown", this._boundHandleKeyDown);
  }

  /* --------------- *** Slider resolution *** --------------- */

  resolveSlider() {
    const sel = this.dataset.sliderTarget?.trim();

    if (sel) {
      const el = document.querySelector(sel);

      return el?.slider || null;
    }

    const host = this.closest("card-slider");

    return host?.slider || null;
  }

  /* --------------- *** Paused UI *** --------------- */

  setUiPaused(paused) {
    const pauseText = this.dataset.labelPause || "Pause slideshow";
    const playText = this.dataset.labelPlay || "Play slideshow";

    this.classList.toggle("carousel-play-pause-button--paused", paused);
    this.setAttribute("aria-pressed", paused ? "false" : "true");
    this.setAttribute("aria-label", paused ? playText : pauseText);
  }

  /* --------------- *** User interaction *** --------------- */

  handleClick(event) {
    event.preventDefault();

    if (this.hasAttribute("disabled")) return;

    const swiper = this.resolveSlider();

    if (!swiper || !swiper.autoplay) return;

    if (swiper.autoplay.running) {
      swiper.autoplay.stop();
      this.setUiPaused(true);
    } else {
      swiper.autoplay.start();
      this.setUiPaused(false);
    }
  }

  handleKeyDown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;

    if (this.hasAttribute("disabled")) return;

    event.preventDefault();
    this.handleClick(event);
  }
}

customElements.define("carousel-play-pause-button", CarouselPlayPauseButton);
